import { Svg, Path, G, Defs, ClipPath, Rect } from '@react-pdf/renderer'

export const Facebook = () => {
  return (
    <Svg width='24' height='24' viewBox='0 0 24 24'>
      <G clip-path='url(#clip0_580_5122)'>
        <Path
          d='M12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12C24 5.37264 18.6274 0 12 0Z'
          fill='#FFEA00'
        />
      </G>
      <Defs>
        <ClipPath id='clip0_580_5122'>
          <Rect width='24' height='24' fill='white' />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
